import { Coquille } from '@/components/layout/coquille';
import { ID_CONTENU } from '@/components/layout/lien-evitement';
import { FournisseurSuivi } from '@/lib/fournisseur-suivi';
import { ToastProvider } from '@pms-digital/design-system';
import { Outlet, createRootRoute, useRouterState } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

export const Route = createRootRoute({
  component: Racine,
});

/**
 * Shell of the app: the header and the icon rail of the design system on the connected pages,
 * nothing around the login page. The toasts live here so they survive a change of route (the
 * failed translation sends the user back to the input screen with its toast), and so does the
 * follow-up of the translations launched from the input screen (T1 and T2, #5). The logout lives
 * on the profile page (`/profil`).
 */
function Racine() {
  const chemin = useRouterState({ select: (etat) => etat.location.pathname });
  const surLogin = chemin === '/login';
  // The path the focus was last put for (and not a "first render" flag: strict mode runs an
  // effect twice on mount, which would take the focus on the first load).
  const cheminPrecedent = useRef(chemin);
  useEffect(() => {
    if (cheminPrecedent.current === chemin) return;
    cheminPrecedent.current = chemin;
    document.getElementById(ID_CONTENU)?.focus({ preventScroll: true });
  }, [chemin]);

  return (
    <ToastProvider>
      <FournisseurSuivi />
      {surLogin ? (
        <Outlet />
      ) : (
        <Coquille>
          <Outlet />
        </Coquille>
      )}
    </ToastProvider>
  );
}
